export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.5.14-1101.04",
  commitId: "8e096f7b1c48d984e91a345cd67d2a9cc4b51c97",
  commitTime: "2026-05-14T11:01:04.000Z",
});
